import React, {useContext, useState} from 'react'
import {ElementContext} from '../ElementContext';
import WAPINewTemplateModal from '../modals/WAPINewTemplateModal'
import WhatsappTemplatesTable from '../tables/WhatsappTemplatesTable'
import { Icon } from '@iconify/react';
import { getWhatsappApiTemplates } from '../../helpers/whatsapp-api';
import WhatsappAPISelector from './WhatsappAPISelector';
import { useTranslation } from 'react-i18next';

const WhatsappAPITemplates = () => {
    
    const { setWhatsAPIModalOpen, setWhatsappTemplates, userConfiguration, setApprovedTemplates, selectedWACredentials  } = useContext(ElementContext)
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    // console.log('WhatsappAPITemplates userConfiguration:', userConfiguration)
    
    const handleUpdateTable = async() => {
        try {
            setLoading(true)
            
            // 1️⃣ BUSCAR LAS CREDENCIALES SELECCIONADAS
            const credentials = userConfiguration.whatsappAPIcredentials?.find(
                cred => cred.phoneNumberId === selectedWACredentials
            )
            
            // 2️⃣ VALIDAR QUE EXISTAN
            if (!credentials) {
                console.error('No se encontraron credenciales seleccionadas')
                alert('select credentials first' || 'Por favor selecciona una credencial primero')
                setLoading(false)
                return
            }
            
            // 3️⃣ OBTENER TEMPLATES CON LAS CREDENCIALES
            const whatsappApiTemplates = await getWhatsappApiTemplates(credentials) // 👈 Pasar credentials
            
            if (whatsappApiTemplates.error) {
                throw new Error('Token inválido o expirado')
            }
            
            const allTemplates = whatsappApiTemplates.allTemplates || []
            const approvedTemplates = whatsappApiTemplates.approvedTemplates || []
            
            setWhatsappTemplates(allTemplates)
            setApprovedTemplates(approvedTemplates)
            
        } catch (error) {
            console.error('Error al actualizar templates:', error)
            alert('errorUpdatingTemplates' || 'Error al actualizar plantillas. Verifica que el token sea válido.')
        } finally {
            setLoading(false)
        }
    }

    if(!userConfiguration.whatsappAPIcredentials || userConfiguration.whatsappAPIcredentials.length < 1){
        return <div className='home '>
                    <h1 className='text-center text-mediumblue mt-10'>{t('youDontHaveCreentials')}</h1>
               </div>
    }


  return (
    <div className='home animate__animated animate__fadeIn'>
        <div className="d-flex flex-column table-container pb-3">
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-12">
                        <h2 className='text-mediumblue mt-3 mb-0'>{ t('wApiTemplatesTitle') }</h2>
                        <p className='subtitle'>
                            { t('wApiTemplatesSubtitle') }
                        </p>
                    </div>
                </div>
            </div>

            <div className="container-fluid mt-5">
                <div className="row d-flex justify-content-between align-items-end">
                    <div className='col-4'>
                        <WhatsappAPISelector showTemplateSelector={false}/>
                    </div>

                    <div className='col-4 btn-group'>
                        <button
                            disabled={loading}
                            className="btn btn-sm btn-mediumblue d-flex align-items-center justify-content-center"
                            onClick={ () => setWhatsAPIModalOpen(true) }>
                                <Icon icon="ic:baseline-plus" className='icon-size-m me-1' />
                                {t('newTemplate')}
                        </button>
                        <button
                            disabled={loading}
                            className="btn btn-sm btn-lightblue d-flex align-items-center justify-content-center"
                            onClick={ handleUpdateTable }>
                                <Icon icon="dashicons:update-alt" className='icon-size-m me-1' />
                                {t('updateTable')}
                        </button>
                    </div>
                </div>
            </div>
            
            <div className="container-fluid mt-5 vh-100">
                <div className="row h-100">
                    <div className="col-12">
                        <WhatsappTemplatesTable />
                    </div>
                </div>
            </div>
        </div>

        <WAPINewTemplateModal />
    </div>
  )
}

export default WhatsappAPITemplates